var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("default"),
      !_vm.hidden
        ? [
            _c("div", {
              staticClass: "vertical-gradient vertical-gradient--right"
            }),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showGradient,
                  expression: "showGradient"
                }
              ],
              staticClass: "vertical-gradient vertical-gradient--left"
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }